import clsx from "clsx"
import React from "react"

export const H1 = ({ children }: { children: React.ReactNode }) => {
  return (
    <h1 className="text-xl mb-5 md:text-5xl text-black font-semibold">
      {children}
    </h1>
  )
}

export const H2 = ({ children }: { children: React.ReactNode }) => {
  return (
    <h2 className={clsx("text-lg text-textPrimary mb-4", "md:text-2xl")}>
      {children}
    </h2>
  )
}
